import { Tooltip } from '@ui/themed';
import type { ReactElement } from 'react';

export function withTooltip(content: string | false, element: ReactElement): ReactElement {
  return content ? <Tooltip content={content}>{element}</Tooltip> : element;
}
